import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { CloseIcon, FilterIcon, filterBlackIcon } from "../../assets/images";
import { LoginResponseType } from "../../redux/auth/authTypes";

type AppProps = {
  clientCategoryFilter: any;
  finalCategoryFilterList: any;
  handleClientCategoryChange: any;
  setCategoryOffset: React.Dispatch<React.SetStateAction<number>>;
  setCategoryText: React.Dispatch<React.SetStateAction<string>>;
  fetching: boolean;
  history: any;
  categoryLimit: number;
  apply: boolean;
  setHandleState: any;
  handleState: any;
  setApply: React.Dispatch<React.SetStateAction<boolean>>;
  setOffset: React.Dispatch<React.SetStateAction<number>>;
  loginData: LoginResponseType;
  setClientCategoryFilter: any;
  handleFilter: (data: string, data1: any, data2: any) => void;
  filter: number | null | undefined;
  setFilter: React.Dispatch<React.SetStateAction<any>>;
  selectedClientCategoryFilter: any;
  setSelectedClientCategoryFilter: any;
  scopeofWorkFilter: any;
  finalScopeofWorkFilterList: any;
  handleScopeOfWorkChange: (data: any) => void;
  setscopeofWorkOffset: React.Dispatch<React.SetStateAction<number>>;
  setLocationOffset: React.Dispatch<React.SetStateAction<number>>;
  setScopeofWorkText: React.Dispatch<React.SetStateAction<string>>;
  setLocationText: React.Dispatch<React.SetStateAction<string>>;
  scopeLimit: number;
  setScopeofWorkFilter: any;
  selectedScopeofWorkFilter: number[] | [];
  setSelectedScopeofWorkFilter: React.Dispatch<React.SetStateAction<number[]>>;
  setBranchFilter: React.Dispatch<React.SetStateAction<any>>;
  // handleScopeofWorkFilter: (data: string, data1: any) => void;
  handleScopeofWorkState: any;
  setHandleScopeofWorkState: any;
  branchFinalData: [];
  handleBranchChange: (data: any) => void;
  branchFilter: any;
  locationText: string;
  locationOffset: number;
  locationLimit: number;
  filterCount: any;
  setFilterCount: React.Dispatch<React.SetStateAction<any>>;
};
const ClientDirectoryFilter = ({
  clientCategoryFilter,
  finalCategoryFilterList,
  handleClientCategoryChange,
  setCategoryOffset,
  setCategoryText,
  fetching,
  categoryLimit,
  loginData,
  setClientCategoryFilter,
  handleFilter,
  setFilter,
  filter,
  selectedClientCategoryFilter,
  setSelectedClientCategoryFilter,
  setOffset,
  history,
  setApply,
  apply,
  setHandleState,
  handleState,
  scopeofWorkFilter,
  // handleScopeofWorkFilter,
  finalScopeofWorkFilterList,
  handleScopeOfWorkChange,
  setscopeofWorkOffset,
  setScopeofWorkText,
  scopeLimit,
  setScopeofWorkFilter,
  selectedScopeofWorkFilter,
  setSelectedScopeofWorkFilter,
  setHandleScopeofWorkState,
  handleScopeofWorkState,
  branchFinalData,
  handleBranchChange,
  branchFilter,
  setLocationOffset,
  setBranchFilter,
  setLocationText,
  locationText,
  locationOffset,
  locationLimit,
  filterCount,
  setFilterCount,
}: AppProps) => {
  filterCount = Object?.values(filterCount)?.reduce(
    (acc: any, curr: any) => acc + curr,
    0
  );
  const [accessToOthersText, setAccessToOthersText] = useState<string>("");
  const [accessToScopeOthersText, setAccessToScopeOthersText] =
    useState<string>("");
  const checkBottom = (e: any) => {
    setCategoryOffset((prv: any) => prv + categoryLimit);
  };
  const checkScopeBottom = (e: any) => {
    setscopeofWorkOffset((prv: any) => prv + scopeLimit);
  };
  const checkBranchBottom = (e: any) => {
    setLocationOffset((prv: any) => prv + locationLimit);
  };
  const [toggle, setToggle] = useState<boolean>(false);

  useEffect(() => {
    if (clientCategoryFilter?.length && scopeofWorkFilter?.length) {
      setFilter(
        selectedClientCategoryFilter.join(",") +
          "," +
          selectedScopeofWorkFilter.join(",")
      );
    } else if (clientCategoryFilter?.length) {
      setFilter(selectedClientCategoryFilter.join(","));
    } else if (scopeofWorkFilter?.length) {
      setFilter(selectedScopeofWorkFilter.join(","));
    } else if (branchFilter?.value) {
      setFilter(branchFilter?.value);
    }
  }, [selectedScopeofWorkFilter, selectedClientCategoryFilter, branchFilter]);

  const handleSubmit = () => {
    setSelectedClientCategoryFilter(handleState ? handleState : []);
    setSelectedScopeofWorkFilter(
      handleScopeofWorkState ? handleScopeofWorkState : []
    );
    setApply(true);
    handleFilter(
      "add",
      handleState ? handleState : [],
      handleScopeofWorkState ? handleScopeofWorkState : []
    );

    setCategoryOffset(0);
    setscopeofWorkOffset(0);
  };

  const clearFilter = () => {
    delete history?.location?.state?.persistCategory;
    delete history?.location?.state?.persistcategoryFilter;
    delete history?.location?.state?.persistScope;
    delete history?.location?.state?.persistScopeFilter;
    delete history?.location?.state?.persistBranch;
    setApply(false);
    setCategoryOffset(0);
    setscopeofWorkOffset(0);
    setClientCategoryFilter({
      value: null,
      label: "Select Client...",
    });
    setScopeofWorkFilter({
      value: null,
      label: "Select Client...",
    });
    setBranchFilter({
      value: null,
      label: "Select...",
    });
    setSelectedClientCategoryFilter([]);
    setSelectedScopeofWorkFilter([]);
    setHandleScopeofWorkState([]);
    setHandleState([]);
    if (filter) {
      handleFilter(
        "clear",
        handleState ? handleState : [],
        handleScopeofWorkState ? handleScopeofWorkState : []
      );
    }
    // setFilter(null);
  };

  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        setToggle(!toggle);
        if (!apply) {
          setClientCategoryFilter({
            value: null,
            label: "Select Client...",
          });
        }
        if (!filter) {
        }
        // FUTURE USE
        //   if(selectedScopeofWorkFilter){
        //     let newFilterValue:any=[]
        // selectedScopeofWorkFilter?.map((e:any)=>{
        // scopeofWorkFilter?.map((item:any)=>{
        //      if( item?.label === e){
        //       newFilterValue?.push(item)
        //      }
        //     })

        //     })
        //     setScopeofWorkFilter(newFilterValue)
        // }
      }}
    >
      <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 250 }}
        overlay={<Tooltip id="button-view-download-invoice">Filter</Tooltip>}
      >
        <DropdownToggle
          caret
          color="secondary"
          style={
            toggle ||
            clientCategoryFilter[0]?.label != undefined ||
            scopeofWorkFilter[0]?.label != undefined ||
            branchFilter?.value
              ? {
                  color: "#dd4433",
                  border: "1px solid #dd4433",
                  backgroundColor: "#fff6f5",
                  display:"flex",
                  alignItems:"center",
                }
              : {
                  border: "1px solid #bfcbe1",
                }
          }
          outline
        >
          <span className={filterCount > 0 ? "payment-count" : ""}>
            <span>{filterCount > 0 ? filterCount : ""}</span>
          </span>
          <img src={toggle ? FilterIcon : filterBlackIcon} alt="" />
        </DropdownToggle>
      </OverlayTrigger>
      <DropdownMenu right>
        <div className="download-dropdown p-3">
          <div className="d-flex justify-content-between align-items-center mt-0 mb-0">
            <h5 className="text-center ">Filter</h5>
            <div
              className="pointer"
              onClick={() => {
                setToggle(!toggle);

                if (!filter) {
                  setFilter(null);
                }
              }}
            >
              <img src={CloseIcon} alt="" />
            </div>
          </div>
          <hr className="mt-0 mb-0" />
          <div className="mt-4 ml-1">
            <label>Client Category</label>
            <Select
              className="dropdown"
              placeholder={
                <div style={{ color: "hsl(0, 0%, 20%)" }}>Select...</div>
              }
              value={
                clientCategoryFilter[0]?.label
                  ? clientCategoryFilter?.filter(
                      (e: any) => e?.value !== loginData?.user_id
                    )
                  : []
              }
              options={finalCategoryFilterList}
              onChange={handleClientCategoryChange}
              isMulti
              isClearable
              isLoading={fetching && accessToOthersText?.length > 0}
              isSearchable={true}
              onMenuScrollToBottom={(e: any) => checkBottom(e)}
              onInputChange={(e: string) => {
                setCategoryText(e);
                setAccessToOthersText(e);
                setCategoryOffset(0);
              }}
            />
          </div>
          {/* scope of work */}
          <div className="mt-4 ml-1">
            <label>Scope of Work</label>
            <Select
              className="dropdown"
              placeholder={
                <div style={{ color: "hsl(0, 0%, 20%)" }}>Select...</div>
              }
              value={
                scopeofWorkFilter[0]?.label
                  ? scopeofWorkFilter?.filter(
                      (e: any) => e?.value !== loginData?.user_id
                    )
                  : []
              }
              options={finalScopeofWorkFilterList}
              onChange={handleScopeOfWorkChange}
              isMulti
              isClearable
              isLoading={fetching && accessToScopeOthersText?.length > 0}
              isSearchable={true}
              onMenuScrollToBottom={(e: any) => checkScopeBottom(e)}
              onInputChange={(e: string) => {
                setScopeofWorkText(e);
                setAccessToScopeOthersText(e);
                setscopeofWorkOffset(0);
              }}
            />
          </div>

          {/* branch */}
          <div className="mt-4 ml-1">
            <label>Branch</label>
            <Select
              className="dropdown"
              value={branchFilter}
              options={
                branchFinalData
                  ? [{ value: "", label: "Select..." },{ value: "none", label: "None" }, ...branchFinalData]
                  : []
              }
              onChange={handleBranchChange}
              isLoading={fetching && locationText?.length > 0}
              isSearchable={true}
              onMenuScrollToBottom={(e: any) => checkBranchBottom(e)}
              onInputChange={(e: string) => {
                setLocationText(e);
                setLocationOffset(0);
              }}
              placeholder={"Select"}
            />
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end p-3 ">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
            }}
          >
            Clear Filter
          </button>
          <button
            className="btn btn-primary mr-3"
            onClick={() => {
              handleSubmit();
              setToggle(!toggle);
            }}
            // disabled={!clientCategoryFilter?.length}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default ClientDirectoryFilter;
